import {
  useGetUserFirstNameWithFallback,
  useGetUserLastNameWithFallback,
  useGetUserNameWithFallback,
} from '@pba/react-utils';
import { type Event, type EventParticipant, isRegisteredEventParticipant } from 'models';
import { useCallback } from 'react';
import { AvatarWrapper, Card } from 'ui';
import { useUser } from 'features/auth';
import { IconDirectMessageButtonNode } from 'features/chat';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { UserLink, UserPopover } from 'features/users/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { useGetNodeUserAvatar } from 'features/users/hooks';

type P = {
  event: Event;
};

const EventAuthor = ({ event }: P) => {
  const author = event.participants.find((participant) => participant.ref === event.author);

  const { nodeUserData: nodeViewer } = useUser();
  const getAvatarUrl = useGetNodeUserAvatar();
  const getUserFirstNameWithFallback = useGetUserFirstNameWithFallback();
  const getUserLastNameWithFallback = useGetUserLastNameWithFallback();
  const getUserNameWithFallback = useGetUserNameWithFallback();
  const getProviderAvatarUrl = useCallback(
    (provider: EventParticipant) =>
      isRegisteredEventParticipant(provider) ? getAvatarUrl({ size: 'medium', userId: provider.ref }) : undefined,
    [getAvatarUrl],
  );

  if (!author || !isRegisteredEventParticipant(author)) {
    return null;
  }

  return (
    <Card.HorizontalScroll
      items={[author].map((provider) => ({
        children: (
          <UserPopover
            fallback={{ ...provider, profilePhoto: getProviderAvatarUrl(provider) }}
            popoverProps={{ stretch: true }}
            userId={provider.ref}
          >
            <UserLink userId={provider.ref}>
              <AvatarWrapper
                avatar={{
                  src: getProviderAvatarUrl(provider),
                }}
                extra={
                  provider.email ? (
                    <IconDirectMessageButtonNode
                      user={{
                        _id: provider.ref,
                        email: provider.email,
                        firstName: getUserFirstNameWithFallback(provider),
                        lastName: getUserLastNameWithFallback(provider),
                      }}
                      viewer={nodeViewer}
                    />
                  ) : null
                }
                user={{ isViewer: provider.ref === nodeViewer._id, name: getUserNameWithFallback(provider) }}
              />
            </UserLink>
          </UserPopover>
        ),
        key: provider.ref,
      }))}
      title="Author"
    />
  );
};

export default EventAuthor;
